import React, { useState, useEffect } from 'react';
import { getTokenHolders } from '../services/holderService';

const TextHolders: React.FC = () => {
  const [textContent, setTextContent] = useState('Loading...');

  useEffect(() => {
    fetchAndDisplayHolders();
  }, []);

  const fetchAndDisplayHolders = async () => {
    try {
      const holders = await getTokenHolders();
      
      // Create a plain text string with just address and proportion
      let output = '';
      
      holders.forEach((holder) => {
        output += `${holder.address},${holder.proportionOf100k.toFixed(2)}\n`;
      });
      
      setTextContent(output);
    } catch (error) {
      setTextContent(`Error loading data: ${error}`);
    }
  };

  // This uses a pre tag with no styling to display the raw text
  return <pre>{textContent}</pre>;
};

export default TextHolders; 